<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableDefaultAlarmConfigurationDate" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="delete">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="defaultAlarmConfigurationDelmodal = true">{{ $t('ticket.list.delete') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 删除模式框 -->
        <Modal v-model="defaultAlarmConfigurationDelmodal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{monitorIndexName}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeAlarmConfiguration()" :disabled="isDisable">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <Modal v-model="modal" :title="$t('configuration_management.default_alarm_config.editDefaultAlarmConfig')" @on-cancel="cancel('defaultAlarmConfigurationEditForm')" @on-ok="ok('defaultAlarmConfigurationEditForm')"  :loading="loading" :mask-closable="false" width="1000px"
               :okText="$t('alarms.common.ok')" :cancelText="$t('alarms.common.cancel')">
            <Form ref="defaultAlarmConfigurationEditForm" :model="defaultAlarmConfigurationEditForm" :label-width="120" :rules="ruleValidate" >
                <!-- 监控模块 -->
                <FormItem :label="$t('configuration_management.common.monitorModule')">
                    <Row>
                        <Col>
                            <div>{{this.monitorModuleName}}</div>
                        </Col>
                    </Row>
                </FormItem>


                <!-- 类型 -->
                <FormItem :label="$t('configuration_management.common.type')" v-if="this.isBilling==1">
                    <Row>
                        <Col>
                            <div>{{this.types}}</div>
                        </Col>
                    </Row>
                </FormItem>

                <div v-if="this.isBilling==1">
                  <!-- 资源类型 -->
                  <FormItem :label="$t('alarms.common.resourceType')" prop="resourceType">
                    <Select v-model="defaultAlarmConfigurationEditForm.resourceType" style="width:300px;" :transfer="true" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                      <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
                    </Select>
                  </FormItem>
                </div>

                <!-- 规则描述 -->
                <FormItem :label="$t('configuration_management.common.ruleDescription')">
                    <Row :gutter="4">
                        <!-- 监控指标 -->
                        <Col span="4">
                            <Row>
                                <Col>
                                    <Input v-model="monitorIndexName" disabled></Input>
                                </Col>
                            </Row>
                        </Col>
                        <!-- 周期 -->
                        <Col span="3">
                            <Row>
                                <Col>
                                    <Input v-model="cycle" disabled></Input>
                                </Col>
                            </Row>
                        </Col>
                        <!-- 连续周期 -->
                        <Col span="3">
                            <Row>
                                <Col>
                                    <Input v-model="continousCycle" disabled></Input>
                                </Col>
                            </Row>
                        </Col>
                        <!-- 统计数值 -->
                        <Col span="3">
                            <Row>
                                <Col>
                                    <Input v-model="statisticsValue" disabled></Input>
                                </Col>
                            </Row>
                        </Col>
                        <!-- 统计次数 -->
                        <!-- 当统计数值为"最大值"时显示 统计次数下拉框 -->
                        <div v-if="defaultAlarmConfigurationEditForm.statisticsValue==3">
                            <Col span="3">
                                <Row>
                                    <Col>
                                        <Input v-model="statisticsCount" disabled></Input>
                                    </Col>
                                </Row>
                            </Col>
                        </div>

                        <div v-if="isNotIOPS">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <Row>
                                    <Col>
                                        <Input v-model="relationshipSign" disabled></Input>
                                    </Col>
                                </Row>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="5" v-if="defaultAlarmConfigurationEditForm.monitorIndex==40">
                                <FormItem prop="thresholdValues">
                                    <Select v-model="defaultAlarmConfigurationEditForm.thresholdValues" filterable multiple allow-create @on-create="handleCreate" placeholder="阈值" @input="limitcount">
                                        <Option v-for="item in thresholdValuesList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="3" v-else>
                                <FormItem prop="thresholdValue">
                                    <Input v-model="defaultAlarmConfigurationEditForm.thresholdValue" type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="defaultAlarmConfigurationEditForm.unit" disabled></Input>
                                </FormItem>
                            </Col>
                        </div>
                        <div v-if="isIOPS">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <Row>
                                    <Col>
                                        <Input v-model="relationshipSign" disabled></Input>
                                    </Col>
                                </Row>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <div>{{ $t('configuration_management.common.standardValues') }}</div>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="defaultAlarmConfigurationEditForm.unit" disabled></Input>
                                </FormItem>
                            </Col>
                        </div>

                    </Row>
                </FormItem>

                <!-- 当监控模块为“CloudTrail”时 显示事件检查 -->
                <FormItem :label="this.$t('alarms.log.cloudTrail.eventCheck')" prop="cloudTrailNames" v-if="defaultAlarmConfigurationEditForm.monitorModule==9">
                    <Select @on-change="changeCloudTrailNames(defaultAlarmConfigurationEditForm.cloudTrailNames)" :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="defaultAlarmConfigurationEditForm.cloudTrailNames" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleCloudTrailNames" @on-change="selectCloudTrailNamesAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.awsEventName" v-for="(item,index) in cloudTrailNamesList" :key="index">{{item.awsEventName}}</Option>
                    </Select>
                </FormItem>

                <!-- 当指标为"EIP没有EC2attached"、"自动购买预留实例"、"没有EBS attached"、"负载均衡未关联实例"时 显示审批流 -->
                <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.title')" prop="approvalFlow" v-if="defaultAlarmConfigurationEditForm.monitorIndex==12||defaultAlarmConfigurationEditForm.monitorIndex==35||defaultAlarmConfigurationEditForm.monitorIndex==36||defaultAlarmConfigurationEditForm.monitorIndex==40">
                    <Select v-model="defaultAlarmConfigurationEditForm.approvalFlow" style="width:300px;" :transfer="true" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                        <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

              <div v-show="isShowLogGroupName">
                    <FormItem :label="$t('configuration_management.common.logGroupName')" prop="logGroupName" style="width:300px;">
                       <Input v-model="logGroupName"  :placeholder="$t('configuration_management.common.logGroupName')"></Input>
                    </FormItem>
               </div>

                <!-- 优先级 -->
                <FormItem :label="$t('configuration_management.common.priority')" prop="priority">
                    <Select v-model="defaultAlarmConfigurationEditForm.priority" style="width:300px;" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                        <Option :value="item.id" v-for="item in priorityList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 监控时间段 -->
                <FormItem :label="$t('configuration_management.common.monitorPeriod')" prop="isAutoDelayEnroll">
                    <Select v-model="defaultAlarmConfigurationEditForm.monitorPeriod" style="width:300px;" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                      <Option :value="item.id" v-for="item in monitorPeriodList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 报警方式 -->
                <FormItem :label="$t('configuration_management.common.alarmWayList')" prop="noticeTypes">
                  <Select v-model="defaultAlarmConfigurationEditForm.noticeTypes" multiple style="width:300px;" :placeholder="$t('resourceLifecycle.pleaseSelect')">
                    <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>

                <!-- 是否需要Enroll -->
                <FormItem :label="$t('configuration_management.common.isAutoDelayEnrollTypeList')" prop="isAutoDelayEnroll">
                    <RadioGroup v-model="defaultAlarmConfigurationEditForm.isAutoDelayEnroll">
                        <Radio v-for="list in isAutoDelayEnrollTypeList" :label="list.isAutoDelayEnroll" :key="list.value">{{list.label}}</Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
        </Modal>
        <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateDefaultAlarmConfiguration from '../default_alarm_configuration/AddOrUpdateDefaultAlarmConfiguration'
    var tableDefaultAlarmConfigurationVue = {};
    export default {
        name: 'TableDefaultAlarmConfiguration',
        components: {
            AddOrUpdateDefaultAlarmConfiguration
        },
        data () {
            // 当监控指标为“自动购买预留实例”时 阈值要满足1-6个数字至少有一个大于七 换种实现方式为“第一个阈值必需要大于7” 则满足以上需求
            const validKeyWordsRule = (rule, value, callback,options) => {
                if(value[0]<7){
                    callback(new Error('第一个阈值必需要大于7'))
                }else{
                    callback();
                }
            };
            return {
                isShowLogGroupName: false,
                logGroupName: '',
                isAutoDelayEnrollTypeList: [{
                    label: this.$t('companyManagement.yes'),
                    value: 'true',
                    isAutoDelayEnroll: 'true'
                }, {
                    label: this.$t('companyManagement.no'),
                    value: 'false',
                    isAutoDelayEnroll: 'false'
                }],
                singleCloudTrailNames:false,
                cloudTrailNamesList: [],
                monitorModuleName:'',
                current:1,
                dataTotal:0,
                pageSize:10,
                isIOPS:false,
                isNotIOPS:true,
                isBilling:'',
                selection:[],
                loading: true,
                modal:false,
                modal_loading: false, //删除
                defaultAlarmConfigurationDelmodal:false,
                isDisable: false,
                monitorIndexName:'',
                val:'',
                types:'',
                cycle:'',
                continousCycle:'',
                statisticsValue:'',
                statisticsCount:'',
                relationshipSign:'',
                thresholdValuesList:[],
                approvalFlowList:[],
                defaultAlarmConfigurationEditForm: {
                    thresholdValue:'',
                    monitorIndex:'',
                    cycle:'',
                    continousCycle:'',
                    statisticsValue:'',
                    statisticsCount:'',
                    relationshipSign:'',
                    unit:'',
                    monitorModule:'',
                    priority: '',
                    resourceType:'',
                    isAutoDelayEnroll:'',
                    monitorPeriod: '',
                    types: '',
                    thresholdValues:[],
                    approvalFlow:'',
                    noticeTypes: [],
                    cloudTrailNames: []
                },
                // 资源类型
                resourceTypeList:[],
                // 优先级别
                priorityList: [{
                    id: 0,
                    name: 'P1',
                    priority: '0'
                },
                {
                    id: 1,
                    name: 'P2',
                    priority: '1'
                },
                {
                    id: 2,
                    name: 'P3',
                    priority: '2'
                },
                {
                    id: 3,
                    name: 'P4',
                    priority: '3'
                }],
                // 优先级别
                monitorPeriodList: [],
                // 报警方式
                alarmWayList : [],
                ruleValidate: {
                    thresholdValue: [
                        { required: false, message: '请输入阈值'}
                    ],
                    priority: [
                        { required: true, message: '请选择优先级', trigger: 'change',type:'number' }
                    ],
                    resourceType: [
                        { required: true, message: '请选择资源类型', trigger: 'change',type:'number' }
                    ],
                    isAutoDelayEnroll: [
                        {required: true, message: '请选择是否需要Enroll', trigger: 'change'}
                    ],
                    thresholdValues: [
                        { required: true, type: 'array',message: '请选择阈值'},
                        { validator: validKeyWordsRule}
                    ],
                    approvalFlow: [
                        { required: true, message: '请选择审批流', trigger: 'change', type: 'number' }
                    ],
                    noticeTypes: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    cloudTrailNames: [
                        {required: true, type: 'array', message: '请选择事件检查', trigger: 'change'}
                    ]
                },
                columns: [
                    {
                        title: this.$t('configuration_management.common.sequenceId'),
                        minWidth: 150,
                        key: 'sequenceName'
                    },
                    {
                        title: this.$t('configuration_management.common.accountType'),
                        minWidth: 150,
                        key: 'accountTypeName'
                    },
                    {
                        title: this.$t('configuration_management.common.monitorModule'),
                        minWidth: 150,
                        key: 'monitorModuleName',
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.modal=true;
                                        // id
                                        this.defaultAlarmConfigurationEditForm.id = params.row.id;

                                        // 监控模块
                                        /******************************************************/
                                        this.monitorModuleName=params.row.monitorModuleName;
                                        this.defaultAlarmConfigurationEditForm.monitorModule=params.row.monitorModule;
                                        // 查询资源类型
                                        tableDefaultAlarmConfigurationVue.searchResourceType(params.row.accountType);
                                        //查询监控时间段
                                        tableDefaultAlarmConfigurationVue.searchMonitorPeriod();
                                        // 查询报警方式
                                        tableDefaultAlarmConfigurationVue.searchAlarmWay();
                                        this.defaultAlarmConfigurationEditForm.noticeTypes = params.row.noticeTypes;

                                        // 如果监控模块为账务 显示资源类型
                                        if(this.defaultAlarmConfigurationEditForm.monitorModule==2){
                                            this.isBilling=1;
                                            // 资源类型
                                            this.defaultAlarmConfigurationEditForm.resourceType=params.row.resourceType;
                                            //账单类型
                                            this.defaultAlarmConfigurationEditForm.types=params.row.defaultAlarmAccountType;
                                            if(params.row.defaultAlarmAccountType==0){
                                                this.types='单账户';
                                            }else if(params.row.defaultAlarmAccountType==1){
                                                this.types='账户组';
                                            }
                                        }else{
                                            this.isBilling='';
                                        }

                                        //  如果监控模块为“CloudTrail” 显示事件检查
                                        if(this.defaultAlarmConfigurationEditForm.monitorModule==9){
                                            this.queryCloudTrailSecurityEvents();
                                            setTimeout(() => {
                                                this.defaultAlarmConfigurationEditForm.cloudTrailNames=params.row.cloudTrailNames;
                                            }, 1000)
                                        }

                                        // 监控指标
                                        /******************************************************/
                                        this.monitorIndexName=params.row.monitorIndexName;
                                        this.defaultAlarmConfigurationEditForm.monitorIndex=params.row.monitorIndex;
                                        if (this.defaultAlarmConfigurationEditForm.monitorIndex == 59) {
                                              this.isShowLogGroupName = true;
                                              this.logGroupName =  params.row.logGroupName;
                                        }
                                        // 审批流
                                        this.$api.processTemplate.listProcessTemplatesByMetricIndex(
                                            "metricIndex",this.defaultAlarmConfigurationEditForm.monitorIndex)
                                        .then(res => {
                                            this.approvalFlowList=res.data;
                                        })
                                        this.defaultAlarmConfigurationEditForm.approvalFlow=params.row.processTemplateId;


                                       // 如果监控指标为RI匹配时 不显示符号、阈值和单位
                                        if(this.defaultAlarmConfigurationEditForm.monitorIndex==15||this.defaultAlarmConfigurationEditForm.monitorIndex==7||this.defaultAlarmConfigurationEditForm.monitorIndex==8||this.defaultAlarmConfigurationEditForm.monitorIndex==10||this.defaultAlarmConfigurationEditForm.monitorIndex==36||this.defaultAlarmConfigurationEditForm.monitorIndex==56||this.defaultAlarmConfigurationEditForm.monitorIndex==54){
                                            this.isIOPS=false;
                                            this.isNotIOPS=false;
                                        }else if(this.defaultAlarmConfigurationEditForm.monitorIndex==30||this.defaultAlarmConfigurationEditForm.monitorIndex==31||this.defaultAlarmConfigurationEditForm.monitorIndex==34||this.defaultAlarmConfigurationEditForm.monitorIndex==28||this.defaultAlarmConfigurationEditForm.monitorIndex==29){
                                            this.isIOPS=true;
                                            this.isNotIOPS=false;
                                        }else{
                                            this.isNotIOPS=true;
                                            this.isIOPS=false;
                                        }

                                        // 周期
                                        this.cycle=params.row.cycleName;
                                        this.defaultAlarmConfigurationEditForm.cycle=params.row.cycle;

                                        // 连续周期
                                        this.continousCycle=params.row.continousCycleName;
                                        this.defaultAlarmConfigurationEditForm.continousCycle=params.row.continousCycle;

                                        // 统计数值
                                        this.statisticsValue=params.row.statisticsValueName;
                                        this.defaultAlarmConfigurationEditForm.statisticsValue=params.row.statisticsValue;

                                        // 统计次数
                                        this.statisticsCount=params.row.statisticsCountName;
                                        this.defaultAlarmConfigurationEditForm.statisticsCount=params.row.statisticsCount;

                                        // 符号
                                        this.relationshipSign=params.row.relationshipSignName;
                                        this.defaultAlarmConfigurationEditForm.relationshipSign=params.row.relationshipSign;

                                        // 阈值
                                        this.defaultAlarmConfigurationEditForm.thresholdValue=params.row.customerMonitorIndexDefaultValue;
                                        this.thresholdValuesList=params.row.thresholdValueList;
                                        this.defaultAlarmConfigurationEditForm.thresholdValues=params.row.customerMonitorIndexDefaultStringValues;

                                        // 单位
                                        this.defaultAlarmConfigurationEditForm.unit=params.row.unitName;

                                        //优先级
                                        this.defaultAlarmConfigurationEditForm.priority=params.row.customerPriorityId;
                                        //监控时间段
                                        this.defaultAlarmConfigurationEditForm.monitorPeriod=params.row.monitorPeriod;

                                        // Enroll
                                        if(params.row.isAutoDelayEnroll==this.$t('common.yes')){
                                            this.defaultAlarmConfigurationEditForm.isAutoDelayEnroll='true';
                                        }else if(params.row.isAutoDelayEnroll==this.$t('common.no')){
                                            this.defaultAlarmConfigurationEditForm.isAutoDelayEnroll='false';
                                        }
                                    }
                                }
                            },params.row.monitorModuleName);
                        }
                    },
                    {
                        title: this.$t('alarms.common.monitorIndex'),
                        minWidth: 150,
                        key: 'monitorIndexName'
                    },
                    {
                        title: this.$t('configuration_management.common.cycle'),
                        minWidth: 150,
                        key: 'cycleName'
                    },
                    {
                        title: this.$t('configuration_management.common.continuous'),
                        minWidth: 150,
                        key: 'continousCycleName'
                    },
                    {
                        title: this.$t('configuration_management.common.statisticsValue'),
                        minWidth: 150,
                        key: 'statisticsValueName'
                    },
                    {
                        title: this.$t('configuration_management.common.statisticsCount'),
                        minWidth: 150,
                        key: 'statisticsCountName'
                    },
                    {
                      title: this.$t('configuration_management.common.resourceType'),
                      minWidth: 150,
                      key: 'resourceTypeName'
                    },
                    {
                        title: this.$t('configuration_management.common.sign'),
                        minWidth: 150,
                        key: 'relationshipSignName'
                    },
                    {
                        title: this.$t('configuration_management.common.threshold'),
                        minWidth: 150,
                        key: 'customerMonitorIndexDefaultValue',
                        render: (h, params) => {
                            if (params.row.customerMonitorIndexDefaultValue) {
                                return h('div', params.row.customerMonitorIndexDefaultValue);
                            }else{
                                return h('div', params.row.customerMonitorIndexDefaultStringValue);
                            }
                        }
                    },
                    {
                        title: this.$t('configuration_management.common.unit'),
                        minWidth: 150,
                        key: 'unitName'
                    },
                    {
                        title: this.$t('configuration_management.common.priority'),
                        minWidth: 150,
                        key: 'customerPriorityName'
                    },
                    {
                        title:this.$t('configuration_management.customized_alarm_config.isAutoDelayEnroll'),
                        minWidth: 150,
                        key: 'isAutoDelayEnroll'
                    },
                    {
                       title:this.$t('configuration_management.customized_alarm_config.alarmValidityPeriodSecond'),
                       minWidth: 150,
                       key: 'alertRulePeriodValidity'
                    },
                    {
                        title: this.$t('configuration_management.common.monitorPeriod'),
                        minWidth: 150,
                        key: 'monitorPeriodName'
                    },
                    {
                        title: this.$t('configuration_management.common.logGroupName'),
                        minWidth: 150,
                        fixed: 'right',
                        key: 'logGroupName'
                    }
                    /********删除暂时屏蔽 为了防止误操作****************/
                    // {
                    //     title: this.$t('common.operation'),
                    //     slot: 'delete'
                    // }
                ],
                tableDefaultAlarmConfigurationDate: []
            }
        },
        beforeCreate: function() {
            tableDefaultAlarmConfigurationVue = this
        },
        mounted: function(){
            tableDefaultAlarmConfigurationVue.getDefaultAlarmConfigurationData();
        },
        methods: {
            // 控制阈值 最多选择6个阈值
            limitcount(e) {
                if (e.length > 6) {
                    this.$Modal.warning({
                        title: "验证规则",
                        content: '最多选择6个阈值'
                    });
                    e.pop();
                }
            },
            // 创建阈值
            handleCreate (val) {
                if(val>=2&&val<=60){
                    this.thresholdValuesList.push({
                        value: val,
                        label: val
                    });
                }else{
                    this.defaultAlarmConfigurationEditForm.thresholdValues=[];
                    this.$Modal.warning({
                        title: "验证规则",
                        content: '当监控指标为自动购买预留实例时,阈值的范围是2-60'
                    });
                }
            },
            showAll: function(){
                tableDefaultAlarmConfigurationVue.getDefaultAlarmConfigurationData();
            },
            // 分页显示数据
            /****************************************************/
            getDefaultAlarmConfigurationData:function() {
                eventBus.$on('accountTypeNames', function (val) {
                    tableDefaultAlarmConfigurationVue.val = val;
                })
                //分页
                this.$api.customerDefinedAlarmConfiguration.defaultAlertRulePage({
                    "type":tableDefaultAlarmConfigurationVue.val,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.tableDefaultAlarmConfigurationDate = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                    for(var i=0;i<this.tableDefaultAlarmConfigurationDate.length;i++){
                        if(this.tableDefaultAlarmConfigurationDate[i].finalVersionCustomerMonitorIndexDefaultValue == undefined&&this.tableDefaultAlarmConfigurationDate[i].monitorModuleName == '存储') {
                          this.tableDefaultAlarmConfigurationDate[i].finalVersionCustomerMonitorIndexDefaultValue = '标准值'
                        } else {
                          this.tableDefaultAlarmConfigurationDate[i].finalVersionCustomerMonitorIndexDefaultValue =this.tableDefaultAlarmConfigurationDate[i].finalVersionCustomerMonitorIndexDefaultValue;
                        }

                        // isAutoDelayEnroll
                        if(this.tableDefaultAlarmConfigurationDate[i].isAutoDelayEnroll==true){
                            this.tableDefaultAlarmConfigurationDate[i].isAutoDelayEnroll=this.$t('common.yes');
                        }else if(this.tableDefaultAlarmConfigurationDate[i].isAutoDelayEnroll==false){
                            this.tableDefaultAlarmConfigurationDate[i].isAutoDelayEnroll=this.$t('common.no');
                        }
                    }
                });
            },
            changePage: function(current){
                this.current=current;
                tableDefaultAlarmConfigurationVue.getDefaultAlarmConfigurationData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableDefaultAlarmConfigurationVue.getDefaultAlarmConfigurationData();
            },
            // 销毁accountTypeNames
            beforeDestroy: function () {
                eventBus.$off('accountTypeNames');
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.monitorIndexName=this.tableDefaultAlarmConfigurationDate[index].monitorIndexName;
            },
            removeAlarmConfiguration: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.alertRuleConfiguration.alertRuleConfigurationDelete("id",this.tableDefaultAlarmConfigurationDate[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableDefaultAlarmConfigurationVue.showAll();
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.defaultAlarmConfigurationDelmodal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            // 编辑报警规则
            /**********************************************************************************/
            // 查询资源类型
            searchResourceType: function(cloudType){
                tableDefaultAlarmConfigurationVue.$api.billing.searchResourceType("cloudType", cloudType)
                .then(res => {
                    this.resourceTypeList = res.data;
                })
            },
            // 查询监控时间段
            searchMonitorPeriod: function(){
                this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.monitorPeriodList = res.data;
                    })
            },
            // 查询报警方式
            searchAlarmWay: function () {
                this.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.alarmWayList = res.data;
                    })
            },
            /***********事件检查**************************/
            selectCloudTrailNamesAll(){
                this.defaultAlarmConfigurationEditForm.cloudTrailNames = []
                if (this.singleCloudTrailNames) {
                    this.cloudTrailNamesList.map((item) => {
                        this.defaultAlarmConfigurationEditForm.cloudTrailNames.push(item.awsEventName)
                    })
                } else {
                    this.defaultAlarmConfigurationEditForm.cloudTrailNames = []
              }
            },
            // 查询CloudTrail事件
            queryCloudTrailSecurityEvents: function () {
                this.$api.cloudTrail.queryCloudTrailSecurityEvents()
                .then(res => {
                    this.cloudTrailNamesList = res.data;
                })
            },
            // 切换事件检查
            changeCloudTrailNames: function (val) {
                if (val.length === this.cloudTrailNamesList.length&&val.length!=0) {
                    this.singleCloudTrailNames = true
                } else {
                    this.singleCloudTrailNames = false
                }
            },
            // 编辑报警
            /**********************************************************************************/
            ok: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        var alertList={
                            "id":this.defaultAlarmConfigurationEditForm.id,
                            "monitorIndex": this.defaultAlarmConfigurationEditForm.monitorIndex,
                            "cycle": this.defaultAlarmConfigurationEditForm.cycle,
                            "continousCycle": this.defaultAlarmConfigurationEditForm.continousCycle,
                            "statisticsValue": this.defaultAlarmConfigurationEditForm.statisticsValue,
                            "statisticsCount": this.defaultAlarmConfigurationEditForm.statisticsCount,
                            "relationshipSign": this.defaultAlarmConfigurationEditForm.relationshipSign,
                            "monitorModule": this.defaultAlarmConfigurationEditForm.monitorModule,
                            "customerPriorityId":this.defaultAlarmConfigurationEditForm.priority,
                            "resourceType":this.defaultAlarmConfigurationEditForm.resourceType,
                            "isAutoDelayEnroll":this.defaultAlarmConfigurationEditForm.isAutoDelayEnroll,
                            "defaultAlarmAccountType":this.defaultAlarmConfigurationEditForm.types,
                            "monitorPeriod" : this.defaultAlarmConfigurationEditForm.monitorPeriod,
                            "noticeTypes": this.defaultAlarmConfigurationEditForm.noticeTypes
                        };

                        // 如果监控指标为实例健康状态或者系统健康状态
                        if (this.defaultAlarmConfigurationEditForm.monitorIndex == 7 || this.defaultAlarmConfigurationEditForm.monitorIndex == 8) {
                            alertList.customerMonitorIndexDefaultValue = 1;
                        } else if(this.defaultAlarmConfigurationEditForm.monitorIndex==40){
                             alertList.customerMonitorIndexDefaultStringValues=this.defaultAlarmConfigurationEditForm.thresholdValues;
                        }else {
                            alertList.customerMonitorIndexDefaultValue = this.defaultAlarmConfigurationEditForm.thresholdValue;
                        }

                        // 当监控模块为“CloudTrail”时 显示事件检查
                        if(this.defaultAlarmConfigurationEditForm.monitorModule==9){
                            alertList.cloudTrailNames=this.defaultAlarmConfigurationEditForm.cloudTrailNames;
                        }

                        // 当指标为"EIP没有EC2attached"、"自动购买预留实例"、"没有EBS attached"、"负载均衡未关联实例"时 传审批流
                        if(this.defaultAlarmConfigurationEditForm.monitorIndex==12||this.defaultAlarmConfigurationEditForm.monitorIndex==35||this.defaultAlarmConfigurationEditForm.monitorIndex==36||this.defaultAlarmConfigurationEditForm.monitorIndex==40){
                            alertList.processTemplateId=this.defaultAlarmConfigurationEditForm.approvalFlow;
                        }

                        if(this.defaultAlarmConfigurationEditForm.monitorIndex== 59){
                            alertList.logGroupName = this.logGroupName;
                        }


                        // 编辑告警
                        tableDefaultAlarmConfigurationVue.$api.customerDefinedAlarmConfiguration.updateDefaultAlertRule(alertList)
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tableDefaultAlarmConfigurationVue.getDefaultAlarmConfigurationData();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('编辑成功');
                                this.modal = false;
                            },1000);
                        })
                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('编辑失败');
                    }
                });
            },
            // 取消
            cancel: function(name){
                this.modal=false;
                this.$refs[name].resetFields();

            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/default_alarm_configuration/TableDefaultAlarmConfiguration.vue